import { twMerge } from 'tailwind-merge';

export function Section({ className, children }) {
  return <section className={twMerge('h-full p-8', className)}>{children}</section>;
}
